import { DESTINATION_TYPE } from "../../const";

export const destinationType = {
  type: "string",
  enum: Object.values(DESTINATION_TYPE)
};
